import React from 'react';
import { Dialog, Stack, Typography, Button, Box, CircularProgress } from '@mui/material';
import SearchBar from './SearchBar';
import { BackIcon, ClockIcon, CloseIcon } from './Icons/Icons';
import { AppColors } from '../Utils/helper/AppColors';
import { getColorSettings } from '../Utils/helper/commonUtils';

export default function InfiniteScrollDialog({
	open,
	onClose,
	title,
	search,
	setSearch,
	onReset,
	onSelectAll,
	selected = [],
	items = [],
	renderItem,
	fetchMore,
	loading,
	hasMore,
}) {
	const listRef = React.useRef();

	// Infinite scroll handler
	const handleScroll = () => {
		const el = listRef.current;
        // console.log('el', el.scrollHeight);
        // console.log('el', el);
		if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 5 && hasMore && !loading) {
			fetchMore();
		}
	};
    
	const localSettingColors = getColorSettings();
	

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullScreen
			PaperProps={{
				sx: { bgcolor: '#fff' },
			}}
		>
			<Stack gap={2} p={3}>
				{/* Header */}
				<BackIcon size={24} onClick={() => onClose()} />
				<Stack direction="row" alignItems="center" justifyContent="space-between">
					<Stack direction="row" alignItems="center" gap={2}>
						<Typography
							textTransform="capitalize"
							variant="subtitle1"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 600,
								fontSize: 18,
								lineHeight: '150%',
								color: '#1A1A1A',
							}}
						>
							{title}
						</Typography>
						<SearchBar
							search={search}
							setSearch={setSearch}
							color={localSettingColors.fontColor}
							bgColor={localSettingColors.quinary}
							width={'607px'}
							variant={'small'}
							borderRadius={'5px'}
							placeholder="Enter name, email, time zone or department"
						/>
					</Stack>
					<Stack direction="row" gap={1}>
						<Button
							size="small"
							variant="text"
							sx={theme => ({
								color: theme.palette.primary.primary_shade,
								fontSize: 14,
								fontWeight: 600,
								lineHeight: '150%',
								fontFamily: 'Poppins',
								backgroundColor: 'transparent',
								boxShadow: 'none',
								textDecoration: 'none',
								'&:hover': {
									backgroundColor: 'transparent',
									color: theme.palette.primary.primary_shade,
									textDecoration: 'none',
									boxShadow: 'none',
								},
								cursor: 'pointer',
							})}
							onClick={onReset}
							disabled={!selected.length}
						>
							Reset
						</Button>
						<Button
							size="small"
							variant="outlined"
							color='info'
							// sx={{
							// 	fontSize: 12,
							// 	fontWeight: 600,
							// 	lineHeight: '100%',
							// 	fontFamily: 'Poppins',
							// 	border: `2px solid ${colorSettings.buttonBackground}`,
							// 	borderRadius: '5px',
							// 	'&:hover': {
							// 		border: `2px solid ${colorSettings.buttonBackground}`,
							// 		borderRadius: '5px',
							// 		backgroundColor: '#F5F1FF',
							// 	},
							// }}
							onClick={onSelectAll}
							disabled={selected.length === items.length}
						>
							Select All
						</Button>
					</Stack>
				</Stack>

				{/* Infinite Scroll List */}
				<Box
					ref={listRef}
					sx={{
						flex: 1,
						overflowY: 'auto',
						maxHeight: '80vh', // <-- enable scrolling
						minHeight: '300px',
						pr: 1,
                        // border: '1px solid red',
					}}
					onScroll={handleScroll}
				>
					<Stack
						gap={'22px'}
						sx={{
							display: 'flex',
							flexDirection: 'row',
							flexWrap: 'wrap',
							alignItems: 'flex-start',
						}}
					>
						{items.map(renderItem)}
					</Stack>
					{loading && (
						<Box textAlign="center" mt={2}>
							<CircularProgress size={24} />
						</Box>
					)}
					{!hasMore && !loading && (
						<Typography align="center" width="100%" color="grey.400" fontSize={12} mt={2}>
							You have seen all the users
						</Typography>
					)}
				</Box>
			</Stack>
		</Dialog>
	);
}
